import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBehaviorKnowledge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.891 9.79629C10.8266 11.246 9.07578 11.5495 8.22611 10.7251C7.82445 11.5036 6.99451 11.4999 6.62975 11.4008L5.83227 13.2877C5.82401 13.3072 5.80557 13.3198 5.78521 13.3198H4.66005C4.63161 13.3198 4.60855 13.2956 4.60855 13.2658V12.1171C1.19697 11.9144 1.63469 9.4773 2.47149 9.04936C0.952368 7.60336 1.95653 6.29696 2.47149 5.77892C2.66107 5.24474 3.07656 4.44101 3.9906 4.17073M13.8652 6.34781C14.6994 7.59109 14.3735 9.1135 13.2472 9.79756C12.4986 10.2523 11.4386 10.1871 10.8913 9.79756C10.3235 9.39343 10.002 8.69576 10.0545 8.14523M11.3425 3.69711C10.5581 3.23506 8.92218 2.22571 6.83665 2.91493M4.35042 5.21187C3.07619 3.53545 6.02431 1.42723 7.59931 3.77745M12.4824 7.58803C15.083 6.92583 13.3064 2.43909 10.178 4.06079M10.8142 6.07605C10.4923 6.6031 8.75438 6.68416 8.75438 5.10303M9.17911 6.19938C9.03745 6.51921 8.56885 7.11296 7.82731 6.92916M6.83665 8.8359C6.41628 9.4931 4.64543 9.4649 4.58282 8.0003",
		stroke: "#596180",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBehaviorKnowledge;
